import { useEffect, useState } from "react";

/**
 * Hook để detect khi keyboard hiện/ẩn trên mobile
 * @returns {Object} Keyboard state và thông tin
 */
export function useKeyboardDetection() {
  const [keyboardState, setKeyboardState] = useState({
    isVisible: false,
    height: 0,
    availableHeight: window.innerHeight,
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.visualViewport) {
      return;
    }

    const updateKeyboardState = () => {
      const currentHeight = window.visualViewport.height;
      const fullHeight = window.innerHeight;
      const heightDiff = fullHeight - currentHeight;

      // Keyboard được coi là hiện nếu height giảm đi ít nhất 150px (threshold cho keyboard)
      const isKeyboardVisible = heightDiff > 150;

      setKeyboardState({
        isVisible: isKeyboardVisible,
        height: isKeyboardVisible ? heightDiff : 0,
        availableHeight: currentHeight,
      });
    };

    // Initial check
    updateKeyboardState();

    // Listen for viewport changes
    window.visualViewport.addEventListener("resize", updateKeyboardState);

    return () => {
      window.visualViewport.removeEventListener("resize", updateKeyboardState);
    };
  }, []);

  return keyboardState;
}

export default useKeyboardDetection;
